import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer-columns" }
const _hoisted_3 = { class: "footer-left" }
const _hoisted_4 = { class: "footer-element footer-societe" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, " Société ", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "footer-element footer-decouvrir" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, " Découvrir aussi ", -1)
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/guide-demenagement-assurance-garde-meuble-comment-assurer-un-box-de-stockage-x78" }, " Assurance box ")
], -1)
const _hoisted_20 = { class: "footer-right" }
const _hoisted_21 = { class: "footer-element footer-societe" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", null, " Recherche de box de stockage ", -1)
const _hoisted_23 = { class: "footer-columns" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["href"]
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "footer-social" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "footer-element" }, " contact@location-gardemeuble.fr ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "footer-element footer-number" }, " 01.86.65.09.70 ", -1)
const _hoisted_47 = { class: "footer-element" }
const _hoisted_48 = {
  title: "Facebook",
  href: "https://www.facebook.com/LocationGardemeubleSelfStockage/",
  target: "_blank"
}
const _hoisted_49 = {
  title: "Twitter",
  href: "https://twitter.com/gardemeuble",
  target: "_blank"
}
const _hoisted_50 = {
  title: "Linked In",
  href: "https://www.linkedin.com/profile/view?id=112437173&trk=nav_responsive_tab_profile_pic",
  target: "_blank"
}
const _hoisted_51 = { class: "footer-copyright" }
const _hoisted_52 = {
  key: 0,
  class: "no-mobile"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, "Si vous êtes propriétaire d'un centre de stockage, vous aimerez Location-gardemeuble.fr", -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_55 = ["href"]
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_57 = ["href"]
const _hoisted_58 = {
  key: 1,
  class: "footer-element no-mobile"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("a", { href: "https://admin.location-gardemeuble.fr/" }, "ACCÉDEZ À VOTRE INTERFACE", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "footer-element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.$router.resolve({name: 'calculateur'}).href
              }, " Evaluez votre volume ", 8, _hoisted_6)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'a-propos'
              }, " Qui sommes-nous ? ", 8, _hoisted_7)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'guide-du-garde-meuble',
                rel: "nofollow"
              }, " Guide du garde-meuble ", 8, _hoisted_8)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'guide-demenagement-sommaire',
                rel: "nofollow"
              }, " Guide du déménagement ", 8, _hoisted_9)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'contact'
              }, " Nous contacter ", 8, _hoisted_10)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'partenaires'
              }, " Nos partenaires ", 8, _hoisted_11)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'conditions-generales'
              }, " Mentions légales ", 8, _hoisted_12)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'carton-de-demenagement'
              }, " Acheter des cartons pas chers ", 8, _hoisted_15)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.$router.resolve({name: 'editable-1'}).href
              }, " Garde-meuble entre particulier ", 8, _hoisted_16)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.$router.resolve({name: 'editable-4'}).href
              }, " Stockage étudiant ", 8, _hoisted_17)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.$router.resolve({name: 'editable-2'}).href
              }, " Cave ", 8, _hoisted_18)
            ]),
            _hoisted_19
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-region'
                  }, " Garde meuble par région ", 8, _hoisted_24)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-departement'
                  }, " Garde meuble par département ", 8, _hoisted_25)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-aubervilliers-93300-r'
                  }, " Garde meuble Île-de-France ", 8, _hoisted_26)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-evry-91090-r'
                  }, " Location box 91 ", 8, _hoisted_27)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-nanterre-92000-r'
                  }, " Location box 92 ", 8, _hoisted_28)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-bobigny-93000-r'
                  }, " Location box 93 ", 8, _hoisted_29)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-creteil-94000-r'
                  }, " Location box 94 ", 8, _hoisted_30)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-cergy-95000-r'
                  }, " Location box 95 ", 8, _hoisted_31)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-melun-77000-r'
                  }, " Location box 77 ", 8, _hoisted_32)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-versailles-78000-r'
                  }, " Location box 78 ", 8, _hoisted_33)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-paris-75000-r'
                  }, " Garde meuble Paris ", 8, _hoisted_34)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-lyon-69000-r'
                  }, " Garde meuble Lyon ", 8, _hoisted_35)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-marseille-13000-r'
                  }, " Garde meuble Marseille ", 8, _hoisted_36)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-toulouse-31000-r'
                  }, " Garde meuble Toulouse ", 8, _hoisted_37)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-bordeaux-33000-r'
                  }, " Garde meuble Bordeaux ", 8, _hoisted_38)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-lille-59000-r'
                  }, " Garde meuble Lille ", 8, _hoisted_39)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-strasbourg-67000-r'
                  }, " Garde meuble Strasbourg ", 8, _hoisted_40)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-nantes-44000-r'
                  }, " Garde meuble Nantes ", 8, _hoisted_41)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-nice-06000-r'
                  }, " Garde meuble Nice ", 8, _hoisted_42)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: this.store.state.base_url + 'garde-meuble-montpellier-34000-r'
                  }, " Garde meuble Montpellier ", 8, _hoisted_43)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _hoisted_45,
      _hoisted_46,
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("a", _hoisted_48, [
          _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook-f'] })
        ]),
        _createElementVNode("a", _hoisted_49, [
          _createVNode(_component_font_awesome_icon, { icon: ['fab', 'twitter'] })
        ]),
        _createElementVNode("a", _hoisted_50, [
          _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin-in'] })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      (this.store.getters.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _hoisted_53,
            _hoisted_54,
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'aide-aux-proprietaires-de-garde-meuble'
              }, " CONSEIL ", 8, _hoisted_55)
            ]),
            _hoisted_56,
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: this.store.state.base_url + 'proposer-votre-garde-meuble'
              }, " COMMERCIALISEZ VOTRE ÉTABLISSEMENT ", 8, _hoisted_57)
            ])
          ]))
        : _createCommentVNode("", true),
      (this.store.getters.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_61, " © 2011 - " + _toDisplayString(new Date().getFullYear()) + " Location-Gardemeuble ", 1)
    ])
  ]))
}